import Add from "../../table/Add";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";


const AddBeneficiary = () =>{
    const navigate = useNavigate();
    const [chackData, setChackData] = useState<any>([]);
    
    const handleSubmit = async (data: any) =>{
        try{
            const response = await ApiService.axiosApi(`/beneficiarylist`,{
                method: 'Post',
                data: data
            });
            if(response.success){
                toast.success(response.message || "Beneficiary List Added Successfully")
                navigate(-1)
            }else{
                toast.error(response.message || "Failed to add Beneficiary List")
            }
        }catch(error: any){
            toast.error(error.message || "Failed to add Beneficiary List")
        }
    }

    useEffect(()=>{
        const fetchChackData = async ()=>{              
            try{
                const response = await ApiService.axiosApi(`/chack`,{
                    method: 'GET'
                });
                if(response.success){
                    setChackData(response.data.data);
                }
            }catch(error:any){
            toast.error(error.message || "Failed to fetch Chack Data");
        }   }
        fetchChackData();
    },[]);  
 

    return(
        <Add
        title={"Add Beneficiary"}
        parentTitle={"Beneficiary List"}
        onSubmit={handleSubmit}
        fields={[
            {
                name : "SchemeVillage",
                label : "Scheme/Village",
                type : "text"
              },
              {
                 name:"Thasil",
                 label:"Thasil",
                 type:"text"
              },
              {
                name:"KhasaraNo",
                label:"KhasaraNo",
                type:"text"
              },
              {
                name:"PlotNo",
                label:"PlotNo",
                type:"text"
              },
              {
                name:"kisam",
                label:"Kisam",
                type:"text"
              },
              {
                name:"CgaInHa",
                label:"CGA In [Ha]",
                type:"text"
              },
              {
                 name:"UnculArea",
                 label:"Uncultiv. Area",
                 type:"text"
              },
              {
                 name:"CulArea",
                 label:"Cultiv. Area",
                 type:"text"
              },
              {
                 name:"CcaArea",
                 label:"C.C.A Acre",
                 type:"text"
              },
              {
                 name:"NameOfBeneficiary",
                 label:"Name Of Beneficiary",
                 type:"text"
              },
              {
                name: "ChakName",
                label: "Chak",
                isDropdown: true,
                dropdownData: chackData,
                dropdownLabel: "chackName",
                idFieldName: "chakId"
    
            }
            

        ]}
        />
    )
} 
export default AddBeneficiary;